

































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Game, Card } from '../models/simple-war';
import CardComponent from '@/components/CardComponent.vue';
import { getAgoTime } from '../utils/utilities';

@Component({
  components: {
    CardComponent,
  },
})
export default class GameBoardComponent extends Vue {
  @Prop() public game!: Game;
  @Prop() public host!: string;

  public selectedCardIndex!: number;
  public SESSION_TOKEN_STR: string = 'Session-Token';

  public updateGameManually(gameId: string) {
    // console.log('updateGameManually');
    this.$http
      .get(`${this.host}/games/${gameId}`, {
        headers: {
          'Session-Token': this.$cookies.get(this.SESSION_TOKEN_STR),
        },
      })
      .then(
        (result) => {
          if (result.ok && result.data) {
            this.game = result.data;
            this.$emit('updateGameBoard', this.game);
          } else {
            throw new Error(JSON.stringify(result));
          }
        },
        (error) => {
          // console.log(error);
          this.$emit('showError', error);
        },
      );
  }

  public cardClickedHandler(handIndex: number) {
    // console.log(
      // `[GameBoardComponent] got event 'cardClickedEvent' for handIndex=${handIndex}`,
    // );
    this.game.cards.forEach((c) => {
      c.clicked = false;
    });
    this.game.cards[handIndex].clicked = true;
    this.selectedCardIndex = handIndex;
  }

  public dragCardStartHandler(handIndex: number) {
    // console.log(`drag event start, handIndex=${handIndex}`);
    this.game.cards[handIndex].clicked = true;
    this.selectedCardIndex = handIndex;
  }

  public dropCardHandler(i: number, j: number, data: any, event: any) {
    // console.log(`dropped on row=${i}, col=${j}, data=${JSON.stringify(data)}`);

    if (event) {
      event.target.classList.remove('md-elevation-12');
      event.target.classList.add('md-elevation-1');
    }

    if (!data) {
      data = this.game.cards[this.selectedCardIndex];
    }

    if (data && data.clicked) {
      this.$http
        .put(
          `${this.host}/games/putCard/${this.game.id}`,
          {
            row: i,
            col: j,
            cardIndex: this.selectedCardIndex,
            card: data,
          },
          {
            headers: {
              'Session-Token': this.$cookies.get(this.SESSION_TOKEN_STR),
            },
          },
        )
        .then(
          (result) => {
            if (result.ok && result.data) {
              this.game = result.data.game;
              this.$emit('updateGameBoard', this.game);
              if (result.data.status === 'INVALID') {
                this.$emit('showError', result.data.message);
              }
            } else {
              throw new Error(JSON.stringify(result));
            }
          },
          (error) => {
            // console.log(error);
            this.$emit('showError', error);
          },
        );
      this.game.cards.forEach((c) => {
        c.might += 1;
        c.might -= 1;
        c.clicked = false;
      });
    }
  }

  public dragOver(i: number, j: number, data: any, event: any) {
    // console.log(`drag over row:${i}, col:${j}`);
    event.target.classList.remove('md-elevation-1');
    event.target.classList.add('md-elevation-12');
  }

  public dragLeave(i: number, j: number, data: any, event: any) {
    // console.log(`drag leave row:${i}, col:${j}`);
    event.target.classList.remove('md-elevation-12');
    event.target.classList.add('md-elevation-1');
  }

  public discardCardsAndEndTurn(discard: boolean) {
    // console.log(`end turn, discard=${discard}`);
    this.$http
      .get(`${this.host}/games/endTurn/${this.game.id}?discard=${discard}`, {
        headers: {
          'Session-Token': this.$cookies.get(this.SESSION_TOKEN_STR),
        },
      })
      .then(
        (result) => {
          if (result.ok && result.data) {
            this.game = result.data;
            this.$emit('updateGameBoard', this.game);
          } else {
            throw new Error(JSON.stringify(result));
          }
        },
        (error) => {
          // console.log(error);
          this.$emit('showError', error);
        },
      );
  }

  public getAgoTime(dateStr: string, currentStr: string) {
    return getAgoTime(dateStr, currentStr);
  }
}
